// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-information-modal .modal2__container {
    width: 478px;
}

.edit-information-modal .modal2__header__title.baloa-subtitle-2 {
    font-size: 18px;
}

.edit-information-modal__form {
    padding: 18px 40px;
}

.edit-information-modal__form .input-field {
    margin: 40px 0 0 0;
}

.edit-information-modal__form .input-field-label {
    font-size: 14px;
    color: var(--primary-very-dark-color);
}

.edit-information-modal__form .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 16px 8px;
}

.edit-information-modal__form-actions {
    padding: 12px 16px;
    border-top: 1px solid var(--new-gray-background-color);
    text-align: right;
}

.edit-information-modal__form-actions .button {
    margin-left: auto;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .edit-information-modal .modal2__container {
        margin: 0;
        height: 100%;
        max-height: unset;
        border-radius: 0;
        background: var(--white-color);
    }

    .edit-information-modal .modal2__content {
        height: 100%;
    }

    .edit-information-modal__form {
        padding: 40px 12px;
    }

    .edit-information-modal__form-actions {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .edit-information-modal__form-actions .button {
        width: 100%;
    }

    .edit-information-modal__form-actions .button.small {
        font-size: 16px;
        padding: 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/user-settings/components/edit-information-modal/EditInformationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sDAAsD;IACtD,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,SAAS;QACT,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;AACJ","sourcesContent":[".edit-information-modal .modal2__container {\n    width: 478px;\n}\n\n.edit-information-modal .modal2__header__title.baloa-subtitle-2 {\n    font-size: 18px;\n}\n\n.edit-information-modal__form {\n    padding: 18px 40px;\n}\n\n.edit-information-modal__form .input-field {\n    margin: 40px 0 0 0;\n}\n\n.edit-information-modal__form .input-field-label {\n    font-size: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.edit-information-modal__form .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 16px 8px;\n}\n\n.edit-information-modal__form-actions {\n    padding: 12px 16px;\n    border-top: 1px solid var(--new-gray-background-color);\n    text-align: right;\n}\n\n.edit-information-modal__form-actions .button {\n    margin-left: auto;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .edit-information-modal .modal2__container {\n        margin: 0;\n        height: 100%;\n        max-height: unset;\n        border-radius: 0;\n        background: var(--white-color);\n    }\n\n    .edit-information-modal .modal2__content {\n        height: 100%;\n    }\n\n    .edit-information-modal__form {\n        padding: 40px 12px;\n    }\n\n    .edit-information-modal__form-actions {\n        position: fixed;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .edit-information-modal__form-actions .button {\n        width: 100%;\n    }\n\n    .edit-information-modal__form-actions .button.small {\n        font-size: 16px;\n        padding: 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
